import React, { useEffect, useState } from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import {
    Box,
    Divider,
    Grid,
    TextField,
    Dialog,
    Typography,
    CircularProgress,
    IconButton,
    Button,
    FormLabel,
} from '@material-ui/core'
import Autocomplete from '@mui/material/Autocomplete'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import CloseIcon from '@mui/icons-material/Close'
import DoneIcon from '@mui/icons-material/Done'
import UploadIcon from '@mui/icons-material/Upload'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import { useDispatch, useSelector } from 'react-redux'
import { setUpdateInsuranceDetails } from '../../../../store/actions/patient'
import TextBox from '../../../../shared/elements/FormItem/TextBox'
import InsuranceCard from './FindYourCare/InsuranceCard'
import uploadIcon from '../../../../assests/images/upload.png'
import fileIcon from '../../../../assests/images/fileIcon.svg'
import { relationshipOptions } from '../../../../containers/AppointmentBooking/constant'

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            '& .MuiPaper-root': {
                height: 'unset',
                maxHeight: '90vh',
                position: 'relative',
                '@media (max-width: 768px)': {
                    maxHeight: '85vh',
                },
            },
            '& .MuiDialog-paperWidthSm': {
                maxWidth: '780px',
            },
        },
        modalBody: {
            height: '100%',
            background: 'white',
            borderColor: '#FFF',
            borderRadius: '8px',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            '&:focus': {
                outline: 'none',
            },
        },
        scrollableContent: {
            flex: 1,
            overflowY: 'auto',
            overflowX: 'hidden',
            padding: '19.5px 26px 10px 26px',
            maxHeight: 'calc(90vh - 180px)',
        },
        fieldLabel: {
            color: '#667689',
            fontFamily: 'Rubik',
            fontSize: '15px',
            fontWeight: 400,
            marginBottom: '5px',
            display: 'block',
        },
        fieldValue: {
            color: '#303E4E',
            fontFamily: 'Rubik',
            fontSize: '18px',
            fontWeight: 500,
            padding: '10px 0',
            display: 'block',
            lineHeight: '16px',
        },
        existPatient: {
            background: '#5571C6',
            width: '100%',
            paddingTop: '2px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
        },
        existPatientHeader1: {
            fontSize: '24px',
            fontFamily: 'Inter',
            color: '#fff',
            padding: '8px 10px',
            fontWeight: '450',
        },
        fieldContainer: {
            padding: '20px 0',
            position: 'relative',
        },
        editIcon: {
            position: 'absolute',
            right: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            padding: '3px',
            borderRadius: '50%',
            border: '1px solid #5571C6',
            backgroundColor: 'rgb(118 193 193 / 19%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '&:hover': {
                backgroundColor: 'rgb(118 193 193 / 30%)',
            }
        },
        insuranceCardSection: {
            padding: '20px 0',
        },
        insuranceCardFile: {
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            marginTop: '12px',
            padding: '8px 0',
        },
        fileNameDisplay: {
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            color: '#5E7FDB',
            fontSize: '14px',
            fontFamily: 'Rubik',
        },
        replaceButton: {
            color: '#667689',
            fontSize: '14px',
            fontFamily: 'Rubik',
            fontWeight: 400,
            cursor: 'pointer',
            padding: '0',
            border: 'none',
            background: 'none',
            '&:hover': {
                textDecoration: 'underline',
            }
        },
        uploadButton: {
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            color: '#5E7FDB',
            fontSize: '14px',
            fontFamily: 'Rubik',
            fontWeight: 400,
            cursor: 'pointer',
            marginTop: '12px',
            padding: '0',
            border: 'none',
            background: 'none',
            '&:hover': {
                textDecoration: 'underline',
            }
        },
        submitButtonContainer: {
            padding: '10px 26px',
            borderTop: '1px solid #E0E0E0',
            backgroundColor: 'white',
            display: 'flex',
            justifyContent: 'flex-end',
        },
        submitButton: {
            backgroundColor: '#5E7FDB',
            color: 'white',
            padding: '12px 32px',
            borderRadius: '6px',
            fontFamily: 'Rubik',
            fontSize: '16px',
            fontWeight: 500,
            textTransform: 'none',
            '&:hover': {
                backgroundColor: '#4968C4',
            },
            '&:disabled': {
                backgroundColor: '#E0E0E0',
                color: '#9E9E9E',
            }
        },
        dividerSeparator: {
            width: '1px',
            height: '16px',
            backgroundColor: '#D0D5DD',
            margin: '0 8px',
        },
        uploadButton: {
            border: '1px solid #5473C9',
            borderRadius: '5px',
            color: '#4C67B2',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            padding: '10px',
            marginTop: '12px'
        },
        crossButton: {
            color: '#838383',
            fontSize: '13px',
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '10px',
            cursor:'pointer'
        },
        completebutton:{
            color: '#fff',
            fontFamily: 'Inter',
            fontWeight: 500,
            fontSize: '13px'
        },
        insuranceBoxContainer:{
            display: 'flex',
            gap: '38px',
            justifyContent:'flex-start',
            '@media (max-width:768px)': {
                flexDirection: 'column',
            },
        },
        fileName:{
            fontFamily: 'Inter',
            fontWeight: 450,
            fontSize: '15px',
            color: '#4765B8',
            padding: '0px 7px',
            borderRight: '1px solid black'
        },
        replaceButton:{
            fontFamily: 'Inter',
            fontWeight: 500,
            fontSize: '15px',
            color: 'black',
            padding: '0px 5px',
            cursor: 'pointer'
        },
        secondaryUploadButton:{
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            marginTop: '5px',
            cursor: 'pointer'
        },
        confirmDialogPaper: {
            position: 'relative',
            borderRadius: '12px',
            padding: '24px 28px',
            maxWidth: '480px',
        },
        confirmTitle: {
            fontFamily: 'Inter',
            fontWeight: 600,
            fontSize: '20px',
            color: '#111827',
            textAlign: 'center',
            marginBottom: '12px',
        },
        confirmDescription: {
            fontFamily: 'Inter',
            fontWeight: 400,
            fontSize: '14px',
            color: '#4B5563',
            textAlign: 'center',
            marginBottom: '24px',
        },
        confirmActions: {
            display: 'flex',
            justifyContent: 'center',
            gap: '16px',
        },
        cancelButton: {
            border: '1px solid #5E7FDB',
            color: '#5E7FDB',
            background: 'white',
            padding: '8px 20px',
            borderRadius: '6px',
            textTransform: 'none',
            fontWeight: 500,
            '&:hover': {
                background: '#F3F6FF',
            },
        },
        continueButton: {
            backgroundColor: '#5E7FDB',
            color: '#fff',
            padding: '8px 20px',
            borderRadius: '6px',
            textTransform: 'none',
            fontWeight: 500,
            '&:hover': {
                backgroundColor: '#4C67B2',
            },
        },

    }),
)

export const InsuranceModal = ({
    isOpenModal,
    setSteps,
    handleNextStep,
    insuranceData,
    onUpdateInsurance,
    carrierList = [],
}) => {
    const dispatch = useDispatch()
    const classes = useStyles()
    const demographicDetails = useSelector((state) => state?.patient?.amdPatientDetails)
    const [isLoading, setIsLoading] = useState(false)
    const [insuranceModal, setInsuranceModal] = useState(false)
    const [patientInsuranceFront, setPatientInsuranceFront] = useState(insuranceData?.patientInsuranceFront || '')
    const [patientInsuranceBack, setPatientInsuranceBack] = useState(insuranceData?.patientInsuranceBack || '')
    const [uploadProcessFront, setUploadProcessFront] = useState(0)
    const [uploadProcessBack, setUploadProcessBack] = useState(0)
    const [selfpay, setSelfpay] = useState(false)
    const [EditMode, setEditMode] = useState({
        carrier: false,
        subscriber_id: false,
        group_name: false,
        group_number: false,
        relationship: false,
        member_name: false,
        member_dob: false,
    })
    // Store confirmed field values to prevent resets when canceling other field edits
    const [confirmedValues, setConfirmedValues] = useState(null)
    const [confirmOpen, setConfirmOpen] = useState(false)
    const [pendingAction, setPendingAction] = useState(null)


    const validationSchema = Yup.object().shape({
        carrier: Yup.object().nullable().required('Insurance Name is required'),
        subscriber_id: Yup.string().required('Subscriber ID is required'),
        group_name: Yup.string().nullable(),
        group_number: Yup.string().nullable(),
        relationship: Yup.object().nullable().required('Relationship is required'),
        member_name: Yup.string().nullable(),
        member_dob: Yup.string().nullable(),
    })

    const getInitialCarrier = () => {
        if (demographicDetails?.insurance_Id && carrierList.length > 0) {
            const matchingCarrier = carrierList.find(
                (item) => item?.['@id'] === demographicDetails.insurance_Id
            )
            if (matchingCarrier) return matchingCarrier
        }

        if (insuranceData?.carrier && typeof insuranceData.carrier === 'object') {
            return insuranceData.carrier
        }

        if (insuranceData?.insurance_name && carrierList.length > 0) {
            const matchingCarrier = carrierList.find(
                (item) => item?.['@name']?.toLowerCase() === insuranceData.insurance_name?.toLowerCase()
            )
            return matchingCarrier || null
        }

        return carrierList.length > 0 ? carrierList[0] : null
    }

    const getInitialSubscriberId = () => {
        if (demographicDetails?.subscriberNum) {
            return demographicDetails.subscriberNum
        }
        return insuranceData?.subscriber_id || insuranceData?.policy_number
    }

    const getInitialRelationship = () => {
        // Handle relationship from insuranceData (can be object or string)
        let relationshipValue = insuranceData?.relationship || demographicDetails?.relationship_id

        // If it's already an object with 'key' and 'value' properties (from CreateInsuranceForm)
        if (relationshipValue && typeof relationshipValue === 'object' && relationshipValue.value) {
            return relationshipValue
        }

        // If it's a string, find the matching option object
        if (relationshipValue && typeof relationshipValue === 'string') {
            const matchingOption = relationshipOptions.find(
                opt => opt.value === relationshipValue || opt.key === relationshipValue
            )
            return matchingOption || null
        }

        return null
    }

    const formik = useFormik({
        validationSchema,
        enableReinitialize: false,
        initialValues: {
            carrier: getInitialCarrier(),
            subscriber_id: getInitialSubscriberId(),
            group_name: insuranceData?.group_name || demographicDetails?.group_name,
            group_number: insuranceData?.group_number || demographicDetails?.group_number,
            relationship: getInitialRelationship(),
            member_name: insuranceData?.member_name || demographicDetails?.member_name || '',
            member_dob: insuranceData?.member_dob || demographicDetails?.dob || ''
        },
        onSubmit: formSubmit,
    })

    // Initialize confirmed values with initial form values
    useEffect(() => {
        if (!confirmedValues) {
            setConfirmedValues({
                carrier: getInitialCarrier(),
                subscriber_id: getInitialSubscriberId(),
                group_name: insuranceData?.group_name || demographicDetails?.group_name || '',
                group_number: insuranceData?.group_number || demographicDetails?.group_number || '',
                relationship: getInitialRelationship(),
                member_name: insuranceData?.member_name || demographicDetails?.member_name || '',
                member_dob: insuranceData?.member_dob || demographicDetails?.dob || '',
            })
        }
    }, [])

    async function formSubmit(payload) {
        const updateData = {
            ...payload,
            insurance_name: payload.carrier?.['@name'],
            insurance_Id: payload.carrier?.['@id'],
            subscriberNum: payload.subscriber_id,
            group_name: payload.group_name,
            group_number: payload.group_number,
            relationship: payload.relationship,
            responsible_party: payload.responsible_party,
            patientInsuranceFront: patientInsuranceFront,
            patientInsuranceBack: patientInsuranceBack,
        }

        // Dispatch to Redux store
        dispatch(setUpdateInsuranceDetails(updateData))

        if (onUpdateInsurance) {
            onUpdateInsurance(updateData)
        }

        handleNextStep()
    }

    const displayName = (name) => {
        let displayName = name;
        const [fileName, extension] = name.split(".");
        displayName = fileName.slice(0, 20) + "..." + " "+"." + extension;
        return displayName
    }

    const EditIcon = ({ onClick }) => (
        <div className={classes.editIcon} onClick={onClick}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none">
                <path
                    d="M11.334 2.00004C11.5091 1.82494 11.7169 1.68605 11.9457 1.59129C12.1745 1.49653 12.4197 1.44775 12.6673 1.44775C12.9149 1.44775 13.1601 1.49653 13.3889 1.59129C13.6177 1.68605 13.8256 1.82494 14.0007 2.00004C14.1757 2.17513 14.3146 2.383 14.4094 2.61178C14.5042 2.84055 14.5529 3.08575 14.5529 3.33337C14.5529 3.58099 14.5042 3.82619 14.4094 4.05497C14.3146 4.28374 14.1757 4.49161 14.0007 4.66671L5.00065 13.6667L1.33398 14.6667L2.33398 11L11.334 2.00004Z"
                    stroke="#5571C6"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </div>
    )

    const handleUpdateInsurance = (field) => {
        // Build complete payload with all current formik values
        const payload = {
            ...insuranceData,
            carrier: formik.values.carrier,
            insurance_name: formik.values.carrier?.['@name'],
            insurance_Id: formik.values.carrier?.['@id'],
            subscriber_id: formik.values.subscriber_id,
            subscriberNum: formik.values.subscriber_id,
            group_name: formik.values.group_name,
            group_number: formik.values.group_number,
            relationship: formik.values.relationship,
            member_name: formik.values.member_name,
            member_dob: formik.values.member_dob,
            patientInsuranceFront: patientInsuranceFront,
            patientInsuranceBack: patientInsuranceBack,
        }

        // Dispatch to Redux store
        dispatch(setUpdateInsuranceDetails(payload))

        // Also call the callback if provided with complete data
        if (onUpdateInsurance) {
            onUpdateInsurance(payload)
        }
    }

    const onTickPress = (field) => {
        setEditMode((old) => ({
            ...old,
            [field]: false,
        }))
        // Update confirmed values with the current formik values
        setConfirmedValues((prev) => ({
            ...prev,
            ...formik.values,
        }))
        handleUpdateInsurance(field)
    }

    const onCrossPress = (field) => {
        setEditMode((old) => ({
            ...old,
            [field]: false,
        }))
        // Revert to the last confirmed values instead of original props
        if (confirmedValues) {
            formik.setFieldValue(field, confirmedValues[field])
        }
    }

    useEffect(() => {
        formik.validateForm()
    }, [formik.values])

    useEffect(() => {
        if (insuranceData?.patientInsuranceFront) {
            setPatientInsuranceFront(insuranceData.patientInsuranceFront)
        }
        if (insuranceData?.patientInsuranceBack) {
            setPatientInsuranceBack(insuranceData.patientInsuranceBack)
        }
    }, [insuranceData?.patientInsuranceFront, insuranceData?.patientInsuranceBack])

    // Check if carrier is self pay on mount or when carrier changes
    useEffect(() => {
        if (formik.values.carrier?.['@name']?.toLowerCase() === 'self pay') {
            setSelfpay(true)
        } else {
            setSelfpay(false)
        }
    }, [formik.values.carrier])

    if (!insuranceData && !formik.values.carrier && carrierList.length === 0) {
        return (
            <Dialog
                open={isOpenModal}
                fullWidth
                className={classes.root}
                sx={{
                    '& .MuiDialog-paperFullWidth': {
                        maxWidth: '650px',
                    },
                }}>
                <Box className={classes.modalBody}>
                    <div style={{
                        backgroundColor: 'white',
                        height: '400px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                        <CircularProgress />
                    </div>
                </Box>
            </Dialog>
        )
    }

    return (
        <>
        <Dialog
            open={isOpenModal}
            fullWidth
            className={classes.root}
            sx={{
                '& .MuiDialog-paperFullWidth': {
                    maxWidth: '780px',
                },
            }}>
            <Box className={classes.modalBody}>
                {/* Fixed Header */}
                <div className={classes.existPatient}>
                    <Typography className={classes.existPatientHeader1}>
                        Verify Your Insurance
                    </Typography>
                    <IconButton onClick={setSteps}>
                        <CloseIcon style={{ color: '#fff', paddingRight: '8px' }} />
                    </IconButton>
                </div>

                {/* Scrollable Content */}
                <Box className={classes.scrollableContent}>
                    {/* Insurance Name Field */}
                    <div className={classes.fieldContainer}>
                        <Typography className={classes.fieldLabel}>
                            Insurance Name
                        </Typography>
                        {EditMode.carrier ? (
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexDirection: 'column', width: '100%' }}>
                                <div style={{ display: 'flex', gap: '8px', alignItems: 'center', width: '100%' }}>
                                    <Autocomplete
                                        value={formik.values.carrier || null}
                                        options={carrierList}
                                        getOptionLabel={(option) => option['@name'] || ''}
                                        onChange={(_, newValue) => {
                                            if (formik.values.carrier && newValue?.['@id'] !== formik.values.carrier?.['@id']) {
                                                setPendingAction(() => () => {
                                                    formik.setFieldValue('carrier', newValue)
                                                })
                                                setConfirmOpen(true)
                                            } else {
                                                formik.setFieldValue('carrier', newValue)
                                            }
                                        }}
                                        popupIcon={<ExpandMoreIcon />}
                                        fullWidth
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder="Select Insurance"
                                                variant="outlined"
                                                size="small"
                                                error={formik.touched.carrier && Boolean(formik.errors.carrier)}
                                                helperText={formik.touched.carrier && formik.errors.carrier}
                                            />
                                        )}
                                        sx={{ flex: 1 }}
                                    />
                                    <IconButton onClick={() => onCrossPress('carrier')} size="small">
                                        <CloseIcon />
                                    </IconButton>
                                    <IconButton onClick={() => onTickPress('carrier')} size="small">
                                        <DoneIcon />
                                    </IconButton>
                                </div>
                                {!formik.values.carrier && (
                                    <div style={{marginTop: '10px', fontSize:'11px', fontWeight:'400', fontFamily:'Inter', width: '100%'}}>
                                        If you are unable to locate your health plan, please select 'Self pay' and give us a call at (855) 446-8628.
                                    </div>
                                )}
                            </div>
                        ) : (
                            <>
                                <Typography className={classes.fieldValue}>
                                    {formik.values.carrier?.['@name'] || 'Blue Cross Blue Shield'}
                                </Typography>
                                <EditIcon onClick={() => setEditMode({ ...EditMode, carrier: true })} />
                            </>
                        )}
                    </div>

                    <Divider />

                    {/* Subscriber ID Field */}
                    <div className={classes.fieldContainer}>
                        <Typography className={classes.fieldLabel} style={{ opacity: selfpay ? '0.5' : '1' }}>
                            Subscriber ID
                        </Typography>
                        {EditMode.subscriber_id ? (
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    name="subscriber_id"
                                    placeholder="Enter Subscriber ID"
                                    value={formik.values.subscriber_id}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    disabled={selfpay}
                                    error={formik.touched.subscriber_id && Boolean(formik.errors.subscriber_id)}
                                    helperText={formik.touched.subscriber_id && formik.errors.subscriber_id}
                                />
                                <IconButton onClick={() => onCrossPress('subscriber_id')} size="small">
                                    <CloseIcon />
                                </IconButton>
                                <IconButton onClick={() => onTickPress('subscriber_id')} size="small">
                                    <DoneIcon />
                                </IconButton>
                            </div>
                        ) : (
                            <>
                                <Typography className={classes.fieldValue} style={{ opacity: selfpay ? '0.5' : '1' }}>
                                    {formik.values.subscriber_id}
                                </Typography>
                                {!selfpay && <EditIcon onClick={() => setEditMode({ ...EditMode, subscriber_id: true })} />}
                            </>
                        )}
                    </div>

                    <Divider />

                    {/* Group Name Field */}
                    <div className={classes.fieldContainer}>
                        <Typography className={classes.fieldLabel} style={{ opacity: selfpay ? '0.5' : '1' }}>
                            Group Name
                        </Typography>
                        {EditMode.group_name ? (
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    name="group_name"
                                    placeholder="Enter Group Name"
                                    value={formik.values.group_name}
                                    onChange={formik.handleChange}
                                    disabled={selfpay}
                                />
                                <IconButton onClick={() => onCrossPress('group_name')} size="small">
                                    <CloseIcon />
                                </IconButton>
                                <IconButton onClick={() => onTickPress('group_name')} size="small">
                                    <DoneIcon />
                                </IconButton>
                            </div>
                        ) : (
                            <>
                                <Typography className={classes.fieldValue} style={{ opacity: selfpay ? '0.5' : '1' }}>
                                    {formik.values.group_name}
                                </Typography>
                                {!selfpay && <EditIcon onClick={() => setEditMode({ ...EditMode, group_name: true })} />}
                            </>
                        )}
                    </div>

                    <Divider />

                    {/* Group Number Field */}
                    <div className={classes.fieldContainer}>
                        <Typography className={classes.fieldLabel} style={{ opacity: selfpay ? '0.5' : '1' }}>
                            Group Number
                        </Typography>
                        {EditMode.group_number ? (
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    name="group_number"
                                    placeholder="Enter Group Number"
                                    value={formik.values.group_number}
                                    onChange={formik.handleChange}
                                    disabled={selfpay}
                                />
                                <IconButton onClick={() => onCrossPress('group_number')} size="small">
                                    <CloseIcon />
                                </IconButton>
                                <IconButton onClick={() => onTickPress('group_number')} size="small">
                                    <DoneIcon />
                                </IconButton>
                            </div>
                        ) : (
                            <>
                                <Typography className={classes.fieldValue} style={{ opacity: selfpay ? '0.5' : '1' }}>
                                    {formik.values.group_number}
                                </Typography>
                                {!selfpay && <EditIcon onClick={() => setEditMode({ ...EditMode, group_number: true })} />}
                            </>
                        )}
                    </div>

                    <Divider />

                    {/* Relationship to Insured Field */}
                    <div className={classes.fieldContainer}>
                        <Typography className={classes.fieldLabel} style={{ opacity: selfpay ? '0.5' : '1' }}>
                            Relationship to Insured
                        </Typography>
                        {EditMode.relationship ? (
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                <Autocomplete
                                    fullWidth
                                    size="small"
                                    value={formik.values.relationship || null}
                                    options={relationshipOptions}
                                    getOptionLabel={(option) => option?.value || ''}
                                    isOptionEqualToValue={(option, value) => option?.key === value?.key}
                                    onChange={(_, newValue) => {
                                        formik.setFieldValue('relationship', newValue)
                                    }}
                                    disabled={selfpay}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            placeholder="Select Relationship"
                                            error={formik.touched.relationship && Boolean(formik.errors.relationship)}
                                            helperText={formik.touched.relationship && formik.errors.relationship}
                                        />
                                    )}
                                />
                                <IconButton onClick={() => onCrossPress('relationship')} size="small">
                                    <CloseIcon />
                                </IconButton>
                                <IconButton onClick={() => onTickPress('relationship')} size="small">
                                    <DoneIcon />
                                </IconButton>
                            </div>
                        ) : (
                            <>
                                <Typography className={classes.fieldValue} style={{ opacity: selfpay ? '0.5' : '1' }}>
                                    {formik.values.relationship?.value || ''}
                                </Typography>
                                {!selfpay && <EditIcon onClick={() => setEditMode({ ...EditMode, relationship: true })} />}
                            </>
                        )}
                    </div>

                    <Divider />

                    {/* Insurance Card Upload Section */}
                    <div className={classes.insuranceCardSection}>
                        <Typography className={classes.fieldLabel}>
                            Insurance Card
                        </Typography>

                        {patientInsuranceFront?.name && (
                            <>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '15px', justifyContent:'space-between' }}>
                                    <div style={{ display: 'flex', alignItems: 'center'}}>
                                        <img src={fileIcon}/>
                                        <Typography className={classes.fileName}>{patientInsuranceFront?.name.length > 20 ? displayName(patientInsuranceFront?.name) : patientInsuranceFront?.name}</Typography>
                                        <span
                                            className={classes.replaceButton}
                                            onClick={() => {
                                                if (!selfpay) {
                                                    setInsuranceModal(true)
                                                }
                                            }}
                                            style={{ opacity: selfpay ? '0.5' : '1', cursor: selfpay ? 'not-allowed' : 'pointer' }}>
                                            Replace
                                        </span>
                                    </div>
                                    <IconButton onClick={()=>{if (!selfpay) setPatientInsuranceFront('')}} disabled={selfpay}>
                                        <HighlightOffIcon style={{color:'#444444'}}/>
                                    </IconButton>
                                </div>
                                {!patientInsuranceBack?.name &&
                                    <div
                                        className={classes?.secondaryUploadButton}
                                        onClick={() => {
                                            if (!selfpay) {
                                                setInsuranceModal(true)
                                            }
                                        }}
                                        style={{ opacity: selfpay ? '0.5' : '1', cursor: selfpay ? 'not-allowed' : 'pointer' }}>
                                        <img src={uploadIcon}
                                            alt=""
                                            style={{ marginLeft: '-3px' }}/>
                                        <Typography className={classes.fileName} style={{borderRight:'unset'}}>Upload</Typography>
                                    </div>
                                }
                            </>
                        )}
                        {patientInsuranceBack?.name && (
                            <>
                                {!patientInsuranceFront?.name &&
                                    <div
                                        className={classes?.secondaryUploadButton}
                                        onClick={() => {
                                            if (!selfpay) {
                                                setInsuranceModal(true)
                                            }
                                        }}
                                        style={{ opacity: selfpay ? '0.5' : '1', cursor: selfpay ? 'not-allowed' : 'pointer' }}>
                                        <img src={uploadIcon}
                                            alt=""
                                            style={{ marginLeft: '-3px' }}/>
                                        <Typography className={classes.fileName} style={{borderRight:'unset'}}>Upload</Typography>
                                    </div>
                                }
                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '5px', justifyContent:'space-between'}}>
                                    <div style={{ display: 'flex', alignItems: 'center'}}>
                                        <img src={fileIcon}  />
                                        <Typography className={classes.fileName}>{patientInsuranceBack?.name.length > 20 ? displayName(patientInsuranceBack?.name) : patientInsuranceBack?.name}</Typography>
                                        <span
                                            className={classes.replaceButton}
                                            onClick={() => {
                                                if (!selfpay) {
                                                    setInsuranceModal(true)
                                                }
                                            }}
                                            style={{ opacity: selfpay ? '0.5' : '1', cursor: selfpay ? 'not-allowed' : 'pointer' }}>
                                            Replace
                                        </span>
                                    </div>
                                    <IconButton onClick={()=>{if (!selfpay) setPatientInsuranceBack('')}} disabled={selfpay}>
                                        <HighlightOffIcon style={{color:'#444444'}}/>
                                    </IconButton>
                                </div>
                            </>
                        )}
                        {!patientInsuranceFront?.name &&
                            !patientInsuranceBack?.name && (
                                <div
                                    className={classes.uploadButton}
                                    style={{ opacity: selfpay ? '0.5' : '1', cursor: selfpay ? 'not-allowed' : 'pointer' }}
                                    onClick={() => {
                                        if (!selfpay) {
                                            setInsuranceModal(true)
                                        }
                                    }}>
                                    {' '}
                                    Upload picture of your insurance card{' '}
                                    <img
                                        src={uploadIcon}
                                        alt=""
                                        style={{ marginLeft: '3px' }}></img>
                                </div>
                            )}
                    </div>
                </Box>

                {/* Fixed Submit Button */}
                <Box className={classes.submitButtonContainer}>
                    <Button
                        className='providerDetailsButton'
                        style={{ marginRight: '10px' }}
                        disabled={isLoading || !formik.isValid}
                        onClick={formik.handleSubmit}>
                        {isLoading ? 'Loading...' : 'Yes, this information is correct'}
                    </Button>
                </Box>
            </Box>
        </Dialog>

        {/* Insurance Card Upload Modal */}
        <Dialog
            open={insuranceModal}
            onClose={() => setInsuranceModal(false)}
            PaperProps={{
                style: { maxWidth: 'unset' },
            }}>
            <div className={classes.crossButton} onClick={() => setInsuranceModal(false)}>
                <CloseIcon />
            </div>
            <div style={{ padding: '0px 33px 33px 33px' }}>
                <div className={classes?.insuranceBoxContainer}>
                    <InsuranceCard
                        placeholder={'Front of Insurance Card'}
                        insurance={patientInsuranceFront}
                        setPatientInsurance={setPatientInsuranceFront}
                        uploadProgress={uploadProcessFront}
                        setUploadProgress={setUploadProcessFront}
                    />
                    <InsuranceCard
                        placeholder={'Back of Insurance Card'}
                        insurance={patientInsuranceBack}
                        setPatientInsurance={setPatientInsuranceBack}
                        uploadProgress={uploadProcessBack}
                        setUploadProgress={setUploadProcessBack}
                    />
                </div>
                <div className={classes.crossButton}>
                    <Button
                        variant="contained"
                        className='providerDetailsButton'
                        disabled={
                            !patientInsuranceFront?.name &&
                            !patientInsuranceBack?.name
                        }
                        onClick={() => setInsuranceModal(false)}>
                        <span className={classes.completebutton}> Complete</span>
                    </Button>
                </div>
            </div>
        </Dialog>
        <Dialog
    open={confirmOpen}
    onClose={() => setConfirmOpen(false)}
    PaperProps={{ className: classes.confirmDialogPaper }}
>
    <IconButton
        aria-label="close"
        onClick={() => setConfirmOpen(false)}
        style={{ position: 'absolute', right: 8, top: 8, color: '#9E9E9E' }}
    >
        <CloseIcon />
    </IconButton>
    <Typography className={classes.confirmTitle}>
        Change Insurance Information?
    </Typography>

    <Typography className={classes.confirmDescription}>
        You're about to change your insurance selection. If you continue,
        any insurance details you've already entered will be cleared.
        <br />
        Do you want to continue?
    </Typography>

    <Box className={classes.confirmActions}>
        <Button
            className={classes.cancelButton}
            onClick={() => {
                setConfirmOpen(false)
                setPendingAction(null)
            }}
        >
            Cancel
        </Button>

        <Button
            className={classes.continueButton}
            onClick={() => {
                if (pendingAction) pendingAction()

                // Clear related fields
                formik.setFieldValue('subscriber_id', '')
                formik.setFieldValue('group_name', '')
                formik.setFieldValue('group_number', '')
                formik.setFieldValue('relationship', null)
                setPatientInsuranceFront('')
                setPatientInsuranceBack('')

                setConfirmOpen(false)
                setPendingAction(null)
            }}
        >
            Yes, continue
        </Button>
    </Box>
</Dialog>

        </>
    )
}